import { partition } from 'lodash'
import { FormSchema } from './Types'
import { StepSchema } from 'components/Wizards/schemas/Types'

export const useFields = ({ schema }: { schema: FormSchema | StepSchema }) => {
  let allFields = Object.entries(schema.fields)

  const [autoFillFields, manualFields] = partition(allFields, ([_, f]) => f.describe().meta.autoFill)
  const [additionalFields, fields] = partition(autoFillFields, ([_, f]) => f.describe().meta.collapsible)
  let [collapsedFields, mainFields] = partition(fields, ([_, f]) => f.describe().meta.inCollapsibleSection)

  const skipResetFields = allFields.filter((f) => f[1].describe().meta.skipReset)

  return { manualFields, additionalFields, collapsedFields, mainFields, skipResetFields }
}
